var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83755 2.37813C3.83755 2.55244 3.69624 2.69375 3.52192 2.69375L0.681299 2.69375L0.681299 5.53438C0.681299 5.70869 0.539989 5.85 0.365674 5.85C0.191359 5.85 0.0500488 5.70869 0.0500488 5.53438V2.37813C0.0500488 2.20381 0.191359 2.0625 0.365674 2.0625H3.52192C3.69624 2.0625 3.83755 2.20381 3.83755 2.37813Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4126 14.3719C11.4126 14.1976 11.5539 14.0563 11.7282 14.0563H14.5688V11.2156C14.5688 11.0413 14.7101 10.9 14.8844 10.9C15.0587 10.9 15.2001 11.0413 15.2001 11.2156V14.3719C15.2001 14.5462 15.0587 14.6875 14.8844 14.6875H11.7282C11.5539 14.6875 11.4126 14.5462 11.4126 14.3719Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5688 5.53438C14.5688 5.70869 14.7101 5.85 14.8844 5.85C15.0587 5.85 15.2001 5.70869 15.2001 5.53438V2.37813C15.2001 2.20381 15.0587 2.0625 14.8844 2.0625H11.7282C11.5539 2.0625 11.4126 2.20381 11.4126 2.37813C11.4126 2.55244 11.5539 2.69375 11.7282 2.69375L14.5688 2.69375V5.53438Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.365674 10.9C0.539989 10.9 0.681299 11.0413 0.681299 11.2156L0.681298 14.0563H3.52192C3.69624 14.0563 3.83755 14.1976 3.83755 14.3719C3.83755 14.5462 3.69624 14.6875 3.52192 14.6875H0.365673C0.191358 14.6875 0.0500488 14.5462 0.0500488 14.3719V11.2156C0.0500488 11.0413 0.191359 10.9 0.365674 10.9Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62817 8.05938C1.45386 8.05938 1.31255 8.20069 1.31255 8.375C1.31255 8.54932 1.45386 8.69063 1.62817 8.69063H13.6219C13.7962 8.69063 13.9376 8.54932 13.9376 8.375C13.9376 8.20069 13.7962 8.05938 13.6219 8.05938H1.62817Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/Scan.bac42379a9106602792d27ebc4e56e5f.svg";
export { ForwardRef as ReactComponent };